import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components';
import ROUTES from '@/router/routes';
import { PropsWithClassName } from '@/types';
import { cn } from '@/utils';

export const ActionInviteFriends: React.FC<PropsWithClassName> = ({
  className,
}) => {
  const navigate = useNavigate();

  return (
    <Button
      className={cn('underline-offset-4 font-bold', className)}
      type="button"
      variant="text"
      onClick={() => navigate(ROUTES.friendsCup.invite)}
    >
      Invitar amigos
    </Button>
  );
};
